module.exports = __webpack_public_path__ + "img/orchid.f79c52ce.png";